module.exports = __webpack_public_path__ + "img/house.02c32d27.png";